module.exports = __webpack_public_path__ + "static/coronavirus-a1901e52b74865bc7a891ee43f8b2edc.jpg";